/**
 * Pure formatting helpers for the provider-candidate picker,
 * kept separate from `PerActiveAlertDrawer` so they're unit-testable
 * without mounting the drawer.
 */

/**
 * Renders a `distance_km` value to one decimal place for display, or
 * `null` when the candidate has no usable distance (missing/absent
 * geometry) — callers decide the "unavailable" copy for that case.
 */
export function formatDistanceKm(distanceKm: number | null | undefined): string | null {
  if (distanceKm === null || distanceKm === undefined) return null;
  return distanceKm.toFixed(1);
}
